var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.488,
    height: 28.044,
    viewBox: "0 0 33.488 28.044",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.b,.c,.d{stroke:#fff;}.b{stroke-width:0.2px;font-size:12px;font-family: Nunito, GothamRounded-Book, Gotham Rounded;}.c,.d{fill:none;}.c{stroke-linecap:round;}.d{stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.069)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M175.009-338.968h0a42.507,42.507,0,0,1-3.5-3.954c-1.6-2.056-3.5-4.987-3.5-7.273a6.917,6.917,0,0,1,7.008-6.8,6.917,6.917,0,0,1,7.008,6.8c0,2.285-1.906,5.216-3.5,7.273a42.507,42.507,0,0,1-3.5,3.954Zm-4.338-10.444a.56.56,0,0,0-.559.559.553.553,0,0,0,.559.559h.7a3.82,3.82,0,0,0,3.77,3.081,3.476,3.476,0,0,0,2.911-1.521.719.719,0,0,0,.156-.454.709.709,0,0,0-.715-.7.694.694,0,0,0-.559.26,2.158,2.158,0,0,1-1.781.988,2.2,2.2,0,0,1-2.132-1.651h2.34a.553.553,0,0,0,.546-.559.56.56,0,0,0-.546-.559h-2.574c-.013-.169-.013-.34-.013-.52a4.139,4.139,0,0,1,.026-.572h2.561a.546.546,0,0,0,.546-.545.553.553,0,0,0-.546-.559h-2.314a2.155,2.155,0,0,1,2-1.586,2.157,2.157,0,0,1,1.807.923.7.7,0,0,0,.559.26.762.762,0,0,0,.768-.754.773.773,0,0,0-.209-.533,3.539,3.539,0,0,0-2.885-1.326,3.849,3.849,0,0,0-3.692,3.016h-.728a.553.553,0,0,0-.559.559.553.553,0,0,0,.559.545h.519a4.734,4.734,0,0,0-.025.6c0,.166,0,.338.013.494Z",
    transform: "translate(-168 357)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.473 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.008,18.031h0a42.548,42.548,0,0,1-3.5-3.954C1.906,12.02,0,9.089,0,6.8A6.916,6.916,0,0,1,7.008,0a6.916,6.916,0,0,1,7.008,6.8c0,2.285-1.906,5.216-3.5,7.272a42.549,42.549,0,0,1-3.5,3.954Zm0-17.049A5.911,5.911,0,0,0,1.1,6.883c0,3.791,5.85,9.676,5.909,9.735.058-.058,5.909-5.923,5.909-9.735A5.911,5.911,0,0,0,7.008.982Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "b",
    transform: "translate(2.028 11.131)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u20AC"))), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-2973.657,16574.473h6.491",
    transform: "translate(2977.443 -16554.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-2973.657,16574.473h6.491",
    transform: "translate(2996.916 -16554.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-2973.657,16574.473h6.491",
    transform: "translate(2987.179 -16547.998)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-2973.657,16574.473h19.473",
    transform: "translate(2980.688 -16551.244)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-2960.955,16578.154v3.738",
    transform: "translate(2977.723 -16554.926)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompare);
export default __webpack_public_path__ + "static/media/compare.9bdd870f79c761bcd3860a11115b64d8.svg";
export { ForwardRef as ReactComponent };